import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;
const mediaDomain = process.env.REACT_APP_MEDIA_DOMAIN;

export function checkGameSuspendList(params) {
  return authPost(`${baseUrl}/Agent5.ashx`, params);
}
export function checkPlatformList(params) {
  return authPost(`${baseUrl}/Agent6.ashx`, params);
}
export function checkPlatformSetting(params) {
  return authPost(`${baseUrl}/Agent7.ashx`, params);
}
export function checkDownloadList(params) {
  return authPost(`${baseUrl}/Agent11.ashx`, params);
}
export function updateBankAccount(params) {
  return authPost(`${baseUrl}/Agent6.ashx`, params);
}
export function postAgent14(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}
export function createBank(params) {
  return authFormPost(
    `${window.location.protocol}//${mediaDomain}/api/createBank.php`,
    params
  );
}
